import { render, staticRenderFns } from "./OrderDetailsBoard.vue?vue&type=template&id=dffc33b6&scoped=true&"
import script from "./OrderDetailsBoard.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsBoard.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsBoard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderDetailsBoard.vue?vue&type=style&index=1&id=dffc33b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffc33b6",
  null
  
)

export default component.exports